
export function truncateAddress(address: string, startLength: number = 4, endLength: number = 4): string {
  if (!address) return '';
  if (address.length <= startLength + endLength) return address;

  const start = address.slice(0, startLength);
  const end = address.slice(-endLength);

  return `${start}...${end}`;
}

export function percentageOfOwnership (individualBalance: number, totalSupply: number) : string  {
  try {
    const percentage = (individualBalance / totalSupply) * 100;
    return percentage.toFixed(4);
  } catch (error) {
    return "0";
  }
}

export function formatRelativeTime(dateString: string): string {
  const date = new Date(dateString);
  const now = new Date();

  // Calculate the difference in milliseconds
  const diffMs = now.getTime() - date.getTime();

  // Convert to days and minutes
  const days = Math.floor(diffMs / (1000 * 60 * 60 * 24));
  const minutes = Math.floor((diffMs % (1000 * 60 * 60 * 24)) / (1000 * 60));

  // Format the result
  if (days > 0) {
    return `${days}D ${minutes}M`;
  } else {
    return `${minutes}M`;
  }
}